'use client';

import dynamic from 'next/dynamic';
import { Layers3, X } from 'lucide-react';

import { haptic } from '@naumu/ui/lib/haptics/haptics';
import { Button } from '@naumu/ui/components/button';

const SpaceIcon = dynamic(
	() => import('@naumu/ui/components/space-icons').then((module) => module.SpaceIcon),
	{
		ssr: false,
		loading: () => (
			<span
				className="inline-flex size-7 shrink-0 items-center justify-center rounded-lg bg-neutral/8 text-neutral-muted"
				aria-hidden
			>
				<Layers3 className="size-4" />
			</span>
		),
	},
);

interface LinkedSpaceBadgeProps {
	spaceName: string;
	icon?: string | null;
	color?: string | null;
	onDismiss: () => void;
}

export const LinkedSpaceBadge = ({
	spaceName,
	icon,
	color,
	onDismiss,
}: LinkedSpaceBadgeProps) => {
	const handleDismiss = () => {
		haptic('light');
		onDismiss();
	};

	return (
		<div className="inline-flex items-center gap-2 rounded-full border border-border-muted bg-neutral/8 py-1 pl-1 pr-1.5 text-[13px] font-medium text-neutral shadow-floating">
			<SpaceIcon
				name={icon}
				color={color}
				size={28}
				fallbackLabel={spaceName}
			/>
			<span className="max-w-[240px] truncate">{spaceName}</span>
			<Button
				variant="ghost-muted"
				size="xs"
				iconOnly
				type="button"
				aria-label={`Create a new space instead of using ${spaceName}`}
				onClick={handleDismiss}
			>
				<X />
			</Button>
		</div>
	);
};
